import {GameDataAttribute} from './GameDataAttribute';
import {GameDataExtraField} from './GameDataExtraField';
import {GameDataSuccess} from './GameDataSuccess';
import {NotebookEntry} from './NotebookEntry';

// Ré-exporter pour compatibilité
export type {GameDataAttribute} from './GameDataAttribute';
export type {GameDataExtraField} from './GameDataExtraField';
export type {GameDataSuccess} from './GameDataSuccess';
export type {NotebookEntry} from './NotebookEntry';

export interface GameData {
  currentStepNumber?: number;
  nbDifferentSteps: number;
  gameSuccess?: GameDataSuccess | null;
  layerAdventurerId?: string;
  recordedPaths: string;
  lastAction?: string;
  comment?: string;
  progression: number;
  butterflyEffects: GameDataAttribute[];
  skills: GameDataAttribute[];
  objects: GameDataAttribute[];
  adventureExtraFields: GameDataExtraField[];
  stepExtraFields: GameDataExtraField[];
  attributes: GameDataAttribute[];
  notebook?: string; // Chaîne de caractères (VARCHAR(4000) dans le backend) - DEPRECATED, utiliser notebookAuto et notebookManual
  notebookAuto?: NotebookEntry[]; // Notes automatiques ajoutées par les étapes (lecture seule, enrichies automatiquement)
  notebookManual?: NotebookEntry[]; // Notes manuelles du joueur (éditables)
  // Champs optionnels pour l'affichage narratif dans le menu des sauvegardes
  chapterTitle?: string; // Titre du chapitre/location actuelle
  storyTeaser?: string; // Phrase narrative pour résumer l'état de la partie
}

export const createGameData = (
  currentStepNumber?: number,
  startStepNumber?: number,
): GameData => {
  return {
    currentStepNumber: currentStepNumber ?? startStepNumber,
    nbDifferentSteps: 0,
    recordedPaths: '',
    progression: 0,
    butterflyEffects: [],
    skills: [],
    objects: [],
    adventureExtraFields: [],
    stepExtraFields: [],
    attributes: [],
  };
};
